import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { DataTableConfig } from '../model/interfaces/dataTable.interface';
import { OutputResultRequest } from '../model/classes/output.classes';
import { OutputResultModel } from '../model/interfaces/output.interface';

@Injectable()
export class DiagnosticoService {
  private url = 'api/diagnostic';

  constructor(private sxHttp: SxHttpService) { }

  getPaginatedAsObservable(dataTableConfig: DataTableConfig): Observable<any> {
    return this.sxHttp.post(this.url, dataTableConfig)
      .map(response => {
        return response.json().data;
      });
  }

  getDetalle(codtransaccion, systemCode: string): Observable<any> {
    const url = `${this.url}/detail/${codtransaccion}/${systemCode}`;
    return this.sxHttp.get(url)
      .map(response => {
        return response.json().data;
      });
  }

  descargar(codtransaccion): Promise<any> {
    const url = `${this.url}/download/${codtransaccion}`;
    return this.sxHttp.get(url)
      .map(response => response.json().data as any)
      .toPromise();
  }

  getMatchingResults(systemCode: string, request: OutputResultRequest): Observable<OutputResultModel[]> {
    const url = `${this.url}/results/${systemCode}`;
    return this.sxHttp.post(url, request)
                      .map(res => res.json().data);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/diagnostico.service.ts